<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="countries-menu-container" style="position: relative; height: 100%; padding: 10px">
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="國家與經緯度" name="tab1">
        <div style="position: relative; height: 100%; padding: 10px">
          <countries-ponsition
            :refreshTab1="refreshObj.refreshTab1"
            :callback="reload"
          ></countries-ponsition>
        </div>
      </el-tab-pane>
      <el-tab-pane label="國家城市" name="tab2">
        <div style="position: relative; height: 100%; padding: 10px">
          <countries-setting :callback="reload"></countries-setting>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'CountriesMenu',
  components: {
    countriesPonsition: () => import('./components/countriesLatLngComponents.vue'),
    countriesSetting: () => import('./components/countriesSettingComponents.vue'),
  },
  data() {
    return {
      activeName: 'tab1',
      list: null,
      refreshObj: {
        refreshTab1: false,
      },
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
    reload(type) {
      this.refreshObj[type] = false
      setTimeout(() => {
        this.refreshObj[type] = true
      }, 500)
    },
  },
}
</script>

<style>
.el-tabs--card {
  height: calc(80vh - 110px);
}
.el-tab-pane {
  height: calc(80vh - 110px);
  overflow-y: auto;
}
</style>
